module.exports = __webpack_public_path__ + "img/face-sad-sweat.69dd0911.svg";